import { controls,grouped } from "../controls";
const recurring_deposit = {
label: "Recurring Deposits",
pageLabel: "Recurring Deposits",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:true} },
pageType: "history",
formTabs:
 {allTabs: [
{ label: "General", uid: "general" },
{label: "Rd Schedule",uid: "rd_schedule",fastpath:"rd_schedule"}
]},
filter:[
]
,form:[
...controls.displayText({ tab: "general", label: "Scheme",star:false}),
...controls.oc({ tab: "general", c: "Scheme", placeHolder: "Scheme Code", name: "scheme_code",fastpath: "schemes",hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "scheme_display"}),
...controls.magicDateLabel({ tab: "general", label: "As On Date",target: "as_on_date",star:false}),
...controls.magicDate({ tab: "general", name: "as_on_date", dateType: "ontype" }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Installment Amount"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "installment_amount",maxlength:14}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Installment Freq",star:false}),
...controls.autoComplete({tab: "general", name: "installment_freq_code", width: "col-sm-2",controlType: "InstallmentFrequency"}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Number Of Installments",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "number_of_installments",maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.magicDateLabel({ tab: "rd_schedule", label: "Interest Date",target: "interest_date",star:true}),
...controls.magicDate({ tab: "rd_schedule", name: "interest_date", dateType: "ontype" }),
...controls.displayText({ tab: "rd_schedule", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "rd_schedule", label: "Days",star:true}),
...controls.numberOnly({ tab: "rd_schedule",  placeHolder: "", name: "days",maxlength:200}),
...controls.displayText({ tab: "rd_schedule", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "rd_schedule", label: "Months",star:true}),
...controls.numberOnly({ tab: "rd_schedule",  placeHolder: "", name: "months",maxlength:200}),
...controls.displayText({ tab: "rd_schedule", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "rd_schedule", label: "Amount"}),
...controls.floatOnly({ tab: "rd_schedule",  placeHolder: "", name: "amount",maxlength:18}),
...controls.displayText({ tab: "rd_schedule", label: "",width:"col-sm-2"}),

...controls.displayText({ tab:"rd_schedule" ,width:"col-sm-12", label: "" }),
...controls.displayText({ tab:"rd_schedule" ,width:"col-sm-4", label: "" }),
...controls.button({
tab:"rd_schedule",
 label: "ADD",
 style: { padding: 0 },
Bcolor: "success",
 onclick: {
  action: "appendToHTMLTable",
  tableNameField: "rd_schedule",
  requiredField: ["interest_date","days","months","amount",]
}, width: "col-sm-2"
}),
...controls.button({
tab:"rd_schedule",
 label: "CLEAR",
 style: { padding: 0 },
Bcolor: "warning",
 onclick: {
  action: "clearForm",
  tableNameField: "rd_schedule",
  requiredField: ["interest_date","days","months","amount",]
}, width: "col-sm-2"
}),
{
  tab:"rd_schedule",
inputType: "table",
  tableTitle: "",
  deletable: true,
  editable: true,
  tableHeaders: [
    { label: "Sr", type: "autoinc" },
    { label: "Interest Date", field: "interest_date", displaytype: "date"},
    { label: "Days", field: "days"},
    { label: "Months", field: "months"},
    { label: "Amount", field: "amount"},
  ],
  widths: {
    parent: "col-sm-12",
    children: "col-sm-12"
  },
  name: "rd_schedule"
},
]
,history:{
perPage: 10,
reportHeader: "Recurring Deposits",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
]}};
export default recurring_deposit;